/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import type {
  NotificationController,
  NotificationOptions,
  PermissionState,
  PushNotification,
  TokenEvent,
  UnlistenFn
} from '@repo/common/types/NotificationController';

/**
 * Browser stub implementation of NotificationController
 * Most features are not supported in browser environment
 */
export class BrowserNotificationController implements NotificationController {
  async getNotificationToken(): Promise<string> {
    throw new Error('APN token retrieval is not supported in browser environment');
  }

  async requestNotificationPermission(): Promise<PermissionState> {
    return { granted: false, status: 'denied' };
  }

  async checkNotificationPermission(): Promise<boolean> {
    return false;
  }

  async onNotificationReceived(
    _handler: (notification: PushNotification) => void
  ): Promise<UnlistenFn> {
    return () => {};
  }

  async onTokenReceived(_handler: (event: TokenEvent) => void): Promise<UnlistenFn> {
    return () => {};
  }

  async onNotificationTapped(
    _handler: (notification: PushNotification) => void
  ): Promise<UnlistenFn> {
    return () => {};
  }

  async sendNotification(_options: NotificationOptions): Promise<void> {
    // No-op for browser
  }

  async setupNotificationActionListener(_callback: (url: string) => void): Promise<() => void> {
    // No-op for browser
    return () => {};
  }

  async simulateNotificationTapped(_notification: PushNotification): Promise<void> {
    // No-op for browser
  }

  async pollUpcomingEvents(): Promise<void> {
    // No-op for browser
  }
}
